module.exports = __webpack_public_path__ + "static/mlh-badge-2019-dfb725c8c9686956fffe2bf18f292db3.svg";